import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ad84e0c&scoped=true&lang=pug"
import script from "./script.ts?vue&type=script&lang=js&external"
export * from "./script.ts?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=0ad84e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad84e0c",
  null
  
)

export default component.exports